"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcppIdTokenAuthorizationSourceValidation = void 0;
class OcppIdTokenAuthorizationSourceValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 3)) {
            return false;
        }
        return true;
    }
}
exports.OcppIdTokenAuthorizationSourceValidation = OcppIdTokenAuthorizationSourceValidation;
